module.exports = __webpack_public_path__ + "resources/img/img_coolfilter3_m.357c0ad1c6ad9171de56d0c34fb31e6d.png";